import { ChangeDetectionStrategy, Component, effect, input, model, signal } from "@angular/core";
import { S25Util } from "../../util/s25-util";
import { TypeManagerDecorator } from "../../main/type.map.service";
import { PreferenceService } from "../../services/preference.service";
import { s25Resource } from "../../util/s25.resource";
import { S25ToggleButtonModule } from "../s25-toggle-button/s25.toggle.button.module";

@TypeManagerDecorator("s25-ng-preference-toggle")
@Component({
    selector: "s25-ng-preference-toggle",
    template: `
        @if (label()) {
            <!-- lots of places like to set width on labels... -->
            <label style="width: auto">{{ label() }}</label>
        }
        <s25-toggle-button
            [value]="modelValue()"
            [toggleLabel]="label()"
            [trueLabel]="trueLabel()"
            [falseLabel]="falseLabel()"
            [disabled]="modelValue() === undefined || pending()"
            (valueChange)="onModelChange($event)"
        />
    `,
    host: {
        "[class.toggle--inline]": "inline()",
    },
    styles: `
        :host {
            display: inline-flex;
            flex-direction: column;
            align-items: center;
        }
        :host.toggle--inline {
            flex-direction: row;
            gap: 1em;

            > label::after {
                content: ":";
            }
        }
    `,
    imports: [S25ToggleButtonModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class S25PreferenceToggleComponent {
    readonly prefName = input.required<string>();
    readonly modelValue = model<boolean>();
    readonly prefType = input<string>("U");
    readonly label = input<string>("Edit Mode");
    readonly trueValue = input<string>("T");
    readonly falseValue = input<string>("F");
    readonly trueLabel = input<string>("On");
    readonly falseLabel = input<string>("Off");
    readonly inline = input<boolean>(false);

    readonly pending = signal(false);

    readonly prefResource = s25Resource({
        if: () => this.modelValue() === undefined,
        loader: () => PreferenceService.getPreferences([this.prefName()]),
    });

    constructor() {
        effect(() => {
            const prefObj = this.prefResource.value();
            if (!prefObj) return;
            this.modelValue.set(prefObj[this.prefName()]?.value === this.trueValue());
        });
    }

    onModelChange(data: boolean) {
        let daoVal: boolean | string = data;
        if (S25Util.isDefined(this.trueValue()) && data) {
            daoVal = this.trueValue();
        } else if (S25Util.isDefined(this.falseValue()) && !data) {
            daoVal = this.falseValue();
        }
        this.modelValue.set(data);
        this.pending.set(true);
        return PreferenceService.setPreference(this.prefName(), daoVal, this.prefType()).finally(() =>
            this.pending.set(false),
        );
    }
}
